const theme = {
  borderRadius: 'var(--border-radius)',

  colors: {
    primary: 'var(--primary)',
    primaryText: 'var(--primary-text)',
    body: 'var(--body)',
    bodyText: 'var(--body-text)',
  },

  screens: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
    '3xl': '1650px',
  },
};

export default theme;
